import 'babel-polyfill';
import Rails from 'rails-ujs';

import Vue from 'vue/dist/vue.esm';
import { initShowcaseHeroContrast } from '../src/lib/showcase-hero-contrast';

import BootstrapVue from 'bootstrap-vue'
import VueTheMask from 'vue-the-mask';
import vSelect from 'vue-select'
import VCalendar from 'v-calendar';

import axios from 'axios';
import VueAxios from 'vue-axios';
Vue.use(VueAxios, axios);
Vue.axios.defaults.headers.common['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
Vue.axios.defaults.headers.common['Accept'] = 'application/json';
Vue.axios.defaults.headers.common['Content-Type'] = 'application/json';
Vue.axios.defaults.headers.common['Cache-Control'] = 'no-cache, no-store, must-revalidate';


Rails.start();
window.$ = $;
Vue.config.productionTip = false;

Vue.use(VueTheMask);
Vue.use(BootstrapVue);
const vCalendarFormats = {
  title: 'MMMM YYYY',
  weekdays: 'W',
  navMonths: 'MMM',
  input: ['DD.MM.YYYY', 'YYYY-MM-DD', 'YYYY/MM/DD'],
  dayPopover: 'YYYY-MM-DD',
  data: ['YYYY-MM-DD']
};

Vue.use(VCalendar, {
  locale: 'ru-RU',
  firstDayOfWeek: 2,
  formats: vCalendarFormats,
  masks: vCalendarFormats
});

//region Quill editor
Vue.component('v-select', vSelect)

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme
Vue.use(VueQuillEditor, /* { default global options } */)
//endregion

import $ from 'jquery';
require("jquery")
require("@nathanvda/cocoon")

document.addEventListener('DOMContentLoaded', () => {
  const initialGeneral = typeof general !== 'undefined' ? general : {};

  const app = new Vue({
    el: '#app',
    components: {
      AbonementRaceSelectionForm: () => import('../src/components/abonement-race-selection-form'),
      ArchivedHeat: () => import('../src/components/archived_heat'),
      BirthDateInput: () => import('../src/components/birth-date-input.vue'),
      ButtonTo: () => import('../src/components/button-to'),
      CoachAchievementsForm: () => import('../src/components/coach-achievements-form.vue'),
      CommerceCart: () => import('../src/components/commerce/CommerceCart.vue'),
      CustomAlerts: () => import('../src/components/custom_alerts'),
      EventLocationMap: () => import('../src/components/event-location-map'),
      HeatList: () => import('../src/components/heat-list.vue'),
      LightboxGallery: () => import('../src/components/lightbox-gallery.vue'),
      ProductCard: () => import('../src/components/product_card'),
      RegistrationForm: () => import('../src/components/registration-form'),
      RelayTeamSelector: () => import('../src/components/relay-team-selector'),
      SelectHeatOwner: () => import('../src/components/select-heat-owner'),
      SelectPerson: () => import('../src/components/select-person'),
      SubscriptionForm: () => import('../src/components/subscription-form'),
      StatusIcon: () => import('../src/components/status-icon'),
      MedicalCertificateDistances: () => import('../src/components/medical-certificate-distances.vue'),
    },
    data: () => ({
      general: initialGeneral,
      globalVar: initialGeneral.globalVar || {}
    }),
    methods: {
      formatDateParam(value) {
        if (!value) return '';
        if (typeof value === 'string') return value.slice(0, 10);

        const date = value instanceof Date ? value : new Date(value);
        if (Number.isNaN(date.getTime())) return '';

        const year = date.getFullYear();
        const month = `${date.getMonth() + 1}`.padStart(2, '0');
        const day = `${date.getDate()}`.padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
    }
  });

  initShowcaseHeroContrast(document.querySelector('[data-showcase-hero-image]'));

  const stickyCta = document.querySelector('[data-showcase-sticky-cta]');
  const stickyTrigger = document.querySelector('[data-showcase-sticky-trigger]');

  if (stickyCta && stickyTrigger) {
    const setStickyVisibility = isVisible => {
      stickyCta.classList.toggle('showcase-sticky-cta--visible', isVisible);
    };

    const stickyThreshold = () => {
      const stickyStyles = window.getComputedStyle(stickyCta);
      if (stickyStyles.bottom !== 'auto') return 0;

      const topOffset = parseFloat(stickyStyles.top || 0);
      return topOffset + stickyCta.offsetHeight;
    };

    const updateStickyVisibility = () => {
      const triggerRect = stickyTrigger.getBoundingClientRect();
      setStickyVisibility(triggerRect.bottom <= stickyThreshold());
    };

    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    window.addEventListener('resize', updateStickyVisibility);
    updateStickyVisibility();
  }

  const homeStickyHeader = document.querySelector('[data-home-sticky-header]');
  const homeStickyTrigger = document.querySelector('[data-home-sticky-trigger]');

  if (homeStickyHeader && homeStickyTrigger) {
    const setStickyHeaderVisibility = isVisible => {
      homeStickyHeader.classList.toggle('home-sticky-header--visible', isVisible);
    };

    if ('IntersectionObserver' in window) {
      const homeStickyObserver = new IntersectionObserver(([entry]) => {
        setStickyHeaderVisibility(!entry.isIntersecting);
      }, { threshold: 0.01 });

      homeStickyObserver.observe(homeStickyTrigger);
    } else {
      const updateHomeStickyHeader = () => {
        const triggerRect = homeStickyTrigger.getBoundingClientRect();
        setStickyHeaderVisibility(triggerRect.bottom <= 0);
      };

      window.addEventListener('scroll', updateHomeStickyHeader, { passive: true });
      window.addEventListener('resize', updateHomeStickyHeader);
      updateHomeStickyHeader();
    }
  }

  const homeSearchForms = Array.from(document.querySelectorAll('[data-home-search-form]'));

  homeSearchForms.forEach(form => {
    const updateHomeSearchState = () => {
      const hasSearchValue = Array.from(form.elements).some(element => {
        if (!element.name || !element.name.startsWith('q[') || element.disabled || element.type === 'submit') return false;

        return `${element.value || ''}`.trim().length > 0;
      });

      form.classList.toggle('home-search--active', hasSearchValue);
    };

    form.addEventListener('input', updateHomeSearchState);
    form.addEventListener('change', updateHomeSearchState);
    updateHomeSearchState();
  });

  const homeUserMenus = Array.from(document.querySelectorAll('[data-home-user-menu]'));

  if (homeUserMenus.length) {
    const closeHomeUserMenus = exceptMenu => {
      homeUserMenus.forEach(menu => {
        if (menu !== exceptMenu) menu.removeAttribute('open');
      });
    };

    homeUserMenus.forEach(menu => {
      menu.addEventListener('toggle', () => {
        if (menu.open) closeHomeUserMenus(menu);
      });
    });

    document.addEventListener('click', event => {
      if (event.target.closest('[data-home-user-menu]')) return;

      closeHomeUserMenus();
    });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') closeHomeUserMenus();
    });
  }

  const homeMobileMenus = Array.from(document.querySelectorAll('[data-home-mobile-menu]'));

  if (homeMobileMenus.length) {
    const updateHomeMobileMenuHeight = menu => {
      if (!menu.open) return;

      const panel = menu.querySelector('.home-mobile-nav__panel');
      const viewport = window.visualViewport;
      const viewportBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
      const availableHeight = Math.max(0, viewportBottom - panel.getBoundingClientRect().top - 16);
      panel.style.setProperty('--home-mobile-menu-height', `${availableHeight}px`);
    };

    const closeHomeMobileMenus = exceptMenu => {
      homeMobileMenus.forEach(menu => {
        if (menu !== exceptMenu) menu.removeAttribute('open');
      });
    };

    homeMobileMenus.forEach(menu => {
      const summary = menu.querySelector('summary');

      menu.addEventListener('toggle', () => {
        summary.setAttribute('aria-label', menu.open ? 'Закрыть меню' : 'Открыть меню');
        if (menu.open) {
          closeHomeMobileMenus(menu);
          updateHomeMobileMenuHeight(menu);
        }
      });

      menu.addEventListener('focusout', event => {
        if (event.relatedTarget && !menu.contains(event.relatedTarget)) menu.removeAttribute('open');
      });
    });

    const updateHomeMobileMenus = () => {
      homeMobileMenus.forEach(menu => {
        if (!menu.getClientRects().length) menu.removeAttribute('open');
        updateHomeMobileMenuHeight(menu);
      });
    };

    window.addEventListener('resize', updateHomeMobileMenus);
    window.addEventListener('scroll', updateHomeMobileMenus, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateHomeMobileMenus);
      window.visualViewport.addEventListener('scroll', updateHomeMobileMenus);
    }

    document.addEventListener('click', event => {
      if (event.target.closest('[data-home-mobile-menu]')) return;

      closeHomeMobileMenus();
    });

    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;

      const openMenu = homeMobileMenus.find(menu => menu.open);
      closeHomeMobileMenus();
      if (openMenu) openMenu.querySelector('summary').focus();
    });
  }

  const setTransferFeedback = (button, message) => {
    const feedbackId = button.dataset.transferFeedbackId;
    if (!feedbackId) return;

    const feedback = document.getElementById(feedbackId);
    if (!feedback) return;

    feedback.textContent = message;
  };

  const fallbackCopyText = text => {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.top = 0;
    textArea.style.left = '-9999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
  };

  const copyText = text => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }

    fallbackCopyText(text);
    return Promise.resolve();
  };

  document.querySelectorAll('[data-transfer-share-button]').forEach(button => {
    if (navigator.share) {
      button.classList.remove('d-none');
    }
  });

  document.addEventListener('click', async event => {
    const copyButton = event.target.closest('[data-transfer-copy-url]');
    if (copyButton) {
      try {
        await copyText(copyButton.dataset.transferCopyUrl);
        setTransferFeedback(copyButton, 'Ссылка скопирована.');
      } catch (_error) {
        setTransferFeedback(copyButton, 'Не удалось скопировать ссылку.');
      }
      return;
    }

    const shareButton = event.target.closest('[data-transfer-share-url]');
    if (!shareButton) return;

    try {
      await navigator.share({
        title: shareButton.dataset.transferShareTitle,
        text: shareButton.dataset.transferShareText,
        url: shareButton.dataset.transferShareUrl
      });
      setTransferFeedback(shareButton, 'Ссылка отправлена.');
    } catch (error) {
      if (error && error.name === 'AbortError') return;

      try {
        await copyText(shareButton.dataset.transferShareUrl);
        setTransferFeedback(shareButton, 'Ссылка скопирована.');
      } catch (_copyError) {
        setTransferFeedback(shareButton, 'Не удалось подготовить ссылку.');
      }
    }
  });
});

Vue.directive('init', {
  bind: function(el, binding, vnode) {
    vnode.context[binding.arg] = binding.value;
  }
});

// Consent-by-file logic for profile photo uploads
document.addEventListener('DOMContentLoaded', function() {
  // Try to find the photo input and consent checkbox container
  const fileField = document.querySelector('input[type="file"][name*="[photo]"]');
  const consentBoxWrapper = document.querySelector('[data-photo-consent-wrapper], #data_consent_box_wrapper');
  const consentCheckbox = consentBoxWrapper && consentBoxWrapper.querySelector('input[type="checkbox"]');
  if (!fileField || !consentBoxWrapper || !consentCheckbox) return;

  const isFileSelected = () => (fileField.files && fileField.files.length > 0) || !!fileField.value;

  const toggle = () => {
    if (isFileSelected()) {
      consentBoxWrapper.style.display = '';
      consentCheckbox.required = true;
    } else {
      consentBoxWrapper.style.display = 'none';
      consentCheckbox.required = false;
      consentCheckbox.checked = false;
    }
  };

  fileField.addEventListener('change', toggle);
  toggle();
});
